import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { getExpressParams, postExpress } from '../../../service/api';
import CustomCreateMain from '../../presentation/section/custom-create-page/CustomCreateMain';

const CustomCreate = (props) => {
  const [reportLabelData, setReportLabelData] = useState({
    type: null,
    name: null,
    info: [],
    nullLabelItem: [],
    nullLabelItemType: null,
  });

  const [reportFilter, setReportFilter] = useState('');

  const [filteredArray, setFilteredArray] = useState({
    type: null,
    name: null,
    info: [],
    nullLabelItem: [],
    nullLabelItemType: null
  })

  const [selectedReportArray, setSelectedReportArray] = useState([]);
  const [selectedReportQueryArray, setSelectedReportQueryArray] = useState([]);
  const [queryData, setQueryData] = useState(null);
  const [userLabelData, setUserLabelData] = useState([]);

  useEffect(()=>{
    getExpressParams('/query/report-label/userid/all', {
      email: props.currentUser
    }, (response)=>{
      setReportLabelData(MakeLabelTreeData(response.data.reportentity, response.data.BuzzLabel))
      setQueryData (response.data.queryentity);
    })
    getUserLabelData((res)=>setUserLabelData(res));
  },[])

  useEffect(()=>{
    handleSearchBtn(JSON.stringify(reportLabelData));
  }, [reportLabelData])

  useEffect(()=> {
    if(selectedReportArray.length > 0){
      getSelectedReportInfo(selectedReportArray);
    }
  }, [selectedReportArray])

  
  const getUserLabelData = (callback) => {
    getExpressParams('/query/label/userid/all', {
      email: props.currentUser
    }, (response) => {
      callback(response.data.BuzzLabel.info);
    })
  }

  const handleSaveBtn = (customName, labelName, labelID) => {
    postExpress('/query/custom-label/userid', {
      "customName": customName,
      "labelName": labelName,
      "labelID": labelID,
      "email": props.currentUser,
      "reportID": selectedReportArray.map(item=>item.reportID),
    },
    (res)=>{
    })
    getUserLabelData((res)=>setUserLabelData(res));
  }

  const handleSearchInput = (event) => {  
    setReportFilter(event.target.value);
  }

  const handleResetBtn = () => {
    setSelectedReportArray([]);
    setSelectedReportQueryArray([]);
  }

  const handleRemoveBtn = (reportInfo) => {
    setSelectedReportArray(selectedReportArray.filter(item=>item.reportID!=reportInfo));
    setSelectedReportQueryArray(selectedReportQueryArray.filter(item=>item.reportID!=reportInfo));
  }

  const getSelectedReportInfo = (reportArray) => {
    reportArray.forEach(item=>{
      getExpressParams('/query/report-content/userid/reportid', {
        email: props.currentUser,
        reportID: item.reportID
      }, (response) => {
        if(selectedReportQueryArray.some(item2=>{ if(item2.reportID == item.reportID){ return true; }})){
        } 
        else {
          setSelectedReportQueryArray([...selectedReportQueryArray, {
            reportID: item.reportID,
            mainQuery: response.data.basequery,
            subQuery: response.data.subquery
          }])
        }
      })
    })
  }

  const handleSelectedReport = (reportInfo) => {
    if(selectedReportArray.some(item=>{ if(item.reportID == reportInfo.reportID){ return true; }})){
    } 
    else {
      setSelectedReportArray([...selectedReportArray, reportInfo]);
    }


    // setSelectedReport(reportInfo);

    // getExpressParams('/query/report-content/userid/reportid', {
    //   email: props.currentUser,
    //   reportID: reportInfo.reportID
    // }, (response) => {
    //   setSelectedReportQuery({
    //     mainQuery: response.data.basequery,
    //     subQuery: response.data.subquery
    //   })
    // })
  }

  const handleSearchBtn = (originArray) => {
    let tempArray = JSON.parse(originArray);
    tempArray.nullLabelItem = tempArray.nullLabelItem.filter((item)=>!reportFilter || item.name.toLowerCase().startsWith(reportFilter.toLowerCase()));

    tempArray.info.forEach(
      (item) => {
        item.labelItem = item.labelItem.filter((reportItem)=> !reportFilter || reportItem.name.toLowerCase().startsWith(reportFilter.toLowerCase()));
      }
    )
    tempArray.info = tempArray.info.filter(
      ((item)=>item.labelItem.length > 0)
    );
    
    setFilteredArray(tempArray);
    // setResultData(null);
  }

  const MakeLabelTreeData = (nodeData, labelData) => {
    let retLabelTreeData = labelData;
    retLabelTreeData.nullLabelItemType = nodeData.type;
    retLabelTreeData.nullLabelItem = [];
    retLabelTreeData.info.forEach((item,index)=> {
      item.labelItem = [];
      // item.checked = false;
      nodeData.info.filter((filteredNode)=>filteredNode.label==item.labelID).forEach(
        (filteredItem, index) => {
          let pushItem = filteredItem;
          // pushItem.checked = false;
          item.labelItem.push(pushItem);
          item.labelItemType = nodeData.type;
      })
    })
    nodeData.info.filter((filteredNode) => filteredNode.label==null).forEach(
      (item)=>{
        let pushItem = item;
        // pushItem.checked = false;
        retLabelTreeData.nullLabelItem.push(pushItem);
      }
    );
    return retLabelTreeData;
  }

  return (
    <CustomCreateMain handleSaveBtn={handleSaveBtn} handleSelectedReport={handleSelectedReport} reportLabelData={reportLabelData} handleSearchBtn={handleSearchBtn} reportFilter={reportFilter} handleSearchInput={handleSearchInput} filteredArray={filteredArray} handleRemoveBtn={handleRemoveBtn}
    selectedReportArray={selectedReportArray} selectedReportQueryArray={selectedReportQueryArray} queryData={queryData} handleResetBtn={handleResetBtn} userLabelData={userLabelData}
    />
  )
}

const mapStateToProps = (state) => ({
  currentUser: state.AuthManager.status.currentUser
})

export default connect(mapStateToProps) (CustomCreate);